import { Button, Modal } from 'react-bootstrap';

import React, { useContext, useEffect, useState, useRef} from "react";
import { MainContext } from "../store/mainContext";
import ConfirmDialog from './ConfirmDialog'
import http from "../Services/httpService";
import noronServices from "../Services/noronServices";
import { toast } from "react-toastify";
import Select from 'react-select'
export default function OilChangeEdit({ show, handleClose, id }) {
    const { devices } = useContext(MainContext);
    const [showIng, setShowIng] = useState(false);
    const [form, setForm] = useState({ id: 0, modeShow: "OnService", modeAlarm: 'Sms', mode: 'Kilometr', deviceId: 0, name: "", kilometr: 0, day: 0, distance: 0, days: 0 });
    const [isLoading, setIsLoading] = useState(false);
    const [isPosting, setIsPosting] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);
    const [deviceChoice, setDeviceChoice] = useState({})
    const handleCloseIng = () => {
        setShowIng(false);
        handleClose(null);
    }

    useEffect(() => {
        setShowIng(show);
        if (show && id > 0)
            handleLoad(id);
    }, [show, id]);


    const handleLoad = async (id) => {
        setIsLoading(true);
        await noronServices.DeviceServiceGet(id)
            .then(({ data }) => {
                setIsLoading(false);
                if (data.errorCode != 0) {
                    toast.error(data.message, { theme: "colored" });
                    return;
                }
                setDeviceChoice({ value: data.payload.deviceId, label: data.payload.deviceName })
                setForm(data.payload)
            })
            .catch(err => {
                setIsLoading(false);
            });
    }

    const formRef = useRef(null);
    const handlePost = async (e) => {
        e.preventDefault();
        const forms = formRef.current;
        if (forms.checkValidity() === false) {
            toast.error('داده های ورودی را بررسی بفرمایید', { theme: "colored" });
            forms.classList.add('was-validated')
            return;
        }
        setIsPosting(true);
        await noronServices.DeviceServicePost(form)
            .then(({ data }) => {
                setIsPosting(false);
                if (data.errorCode != 0) {
                    toast.error(data.message, { theme: "colored" });
                    return;
                }
                setShowIng(false);
                handleClose(e, form);
            })
            .catch(err => {
                setIsPosting(false);
            });
    }

    const handleDoConfirm = (e) => {
        setShowConfirm(false);
        handlePost(e);
    }


    return (
        <>
            <ConfirmDialog
                show={showConfirm}
                title="توجه"
                handleDo={(e) => handleDoConfirm(e)}
                handleCancel={(e) => setShowConfirm(false)}
                isBusy={false}
            >
                <div className='row'>
                    <div className='col'>
                        <div className="alert alert-danger" role="alert">
                            با ویرایش و ثبت تغییرات، کلیه محاسبات گذشته صفر و از تاریخ جاری محاسبات انجام خواهد شد
                            <br />
                            آیا ثبت اجام شود؟
                        </div>
                    </div>
                </div>
            </ConfirmDialog>
            <Modal show={showIng} onHide={handleCloseIng} id="modalPatient" centered scrollable >
                <Modal.Header closeButton>
                    <Modal.Title className="colorRed">سرویس نگهداری خودرو {form.deviceName}                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {isLoading &&
                        <div className="spinner-border spinner-border-sm" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>}

                    <form ref={formRef} className=" needs-validation container">
                        <div className="row ">
                            <div className="col">
                                <label asp-for="oilDateFa">نام سرویس</label>
                            </div>
                        </div>
                        <div className="row mt-1">
                            <div className="col">
                                <input
                                    asp-for="name"
                                    type="text"
                                    name="name"
                                    value={form.name}
                                    onChange={e => http.handleChange(e, form, setForm)}
                                    required
                                    placeholder="مثلا تعویض روغن یا تعویض تسمه تایم"
                                    className="form-control"
                                    autoComplete="off" />
                                <span asp-validation-for="oilDateFa" className="text-danger"></span>
                            </div>
                        </div>
                        <div className="row mt-3">
                            <div className="col">
                                خودرو
                            </div>
                        </div>
                        <div className="row mt-1 mb-3">
                            <div className="col">
                                <Select
                                    isDisabled={isLoading}
                                    className=' '
                                    placeholder=""
                                    options={devices.map(x => ({ value: x.id, label: x.deviceName }))}
                                    isRtl={true}
                                    value={deviceChoice}
                                    //defaultValue={device ? {value:device.id,label:device.name} : {}}
                                    onChange={
                                        (newValue, actionMeta) => {
                                            console.log(newValue);
                                            setDeviceChoice(newValue)
                                            setForm({ ...form, deviceId: newValue.value });
                                        }
                                    }
                                />
                            </div>
                        </div>
                        <div className="row mt-3">
                            <div className="col">
                                نوع اطلاع رسانی
                            </div>
                        </div>
                        <div className="row mt-1">
                            <div className="col  "  >
                                <div className="border rounded p-3">
                                    <div className="form-check-inline">
                                        <input
                                            type="radio"
                                            name="modeAlarm"
                                            value="Sms"
                                            checked={form.modeAlarm == 'Sms'}
                                            onChange={e => http.handleChange(e, form, setForm)}
                                            className=" form-check-input" />
                                        <label className="form-check-label ms-1" htmlFor="mode1"> پیامک</label >
                                    </div>
                                    <div className="form-check-inline">
                                        <input
                                            type="radio"
                                            name="modeAlarm"
                                            value="Voice"
                                            checked={form.modeAlarm == 'Voice'}
                                            onChange={e => http.handleChange(e, form, setForm)}
                                            className=" form-check-input" />
                                        <label className="form-check-label ms-1" htmlFor="mode2">تماس تلفنی</label >
                                    </div>
                                    <div className="form-check-inline">
                                        <input
                                            type="radio"
                                            name="modeAlarm"
                                            value="SmsVoice"
                                            checked={form.modeAlarm == 'SmsVoice'}
                                            onChange={e => http.handleChange(e, form, setForm)}
                                            className=" form-check-input" />
                                        <label className="form-check-label ms-1" htmlFor="mode2">پیامک و تماس</label >
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row mt-1">
                            <div className="col">
                                <div className='alert alert-success'>
                                    تماس <span className='fw-bold'>تلفنی</span> در <span className='fw-bold'> ساعت 22 </span> انجام خواهد شد<br />
                                    از صحت شماره موبایل وارد شده در حساب کاربری خود اطمینان حاصل فرمایید
                                </div>
                            </div>
                        </div>

                        <div className="row mt-3">
                            <div className="col">
                                تعداد اطلاع رسانی
                            </div>
                        </div>
                        <div className="row mt-1">
                            <div className="col  "  >
                                <div className="border rounded p-3">
                                    <div className="form-check-inline">
                                        <input
                                            type="radio"
                                            name="modeShow"
                                            value="EvryDay"
                                            checked={form.modeShow == 'EvryDay'}
                                            onChange={e => http.handleChange(e, form, setForm)}
                                            className=" form-check-input" />
                                        <label className="form-check-label ms-1" htmlFor="mode1"> هر شب</label >
                                    </div>
                                    <div className="form-check-inline">
                                        <input
                                            type="radio"
                                            name="modeShow"
                                            value="OnService"
                                            checked={form.modeShow == 'OnService'}
                                            onChange={e => http.handleChange(e, form, setForm)}
                                            className=" form-check-input" />
                                        <label className="form-check-label ms-1" htmlFor="mode2">فقط زمان سرویس</label >
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row mt-3">
                            <div className="col">
                                نوع محاسبه
                            </div>
                        </div>
                        <div className="row mt-1">
                            <div className="col  "  >
                                <div className="border rounded p-3">
                                    <div className="form-check-inline">
                                        <input
                                            type="radio"
                                            name="mode"
                                            id="mode1"
                                            value="Kilometr"
                                            checked={form.mode == 'Kilometr'}
                                            onChange={e => http.handleChange(e, form, setForm)}
                                            className=" form-check-input" />
                                        <label className="form-check-label ms-1" htmlFor="mode1"> کیلومتر طی شده</label >
                                    </div>
                                    <div className="form-check-inline">
                                        <input
                                            type="radio"
                                            name="mode"
                                            id="mode2"
                                            value="Time"
                                            checked={form.mode == 'Time'}
                                            onChange={e => http.handleChange(e, form, setForm)}
                                            className=" form-check-input" />
                                        <label className="form-check-label ms-1" htmlFor="mode2"> مدت زمان</label >
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row mt-3">
                            <div className="col">
                                <label disabled={form.mode != 'Kilometr'} asp-for="oilDateFa">کیلومتر سرویس</label>
                            </div>
                        </div>
                        <div className="row mt-1">
                            <div className="col">
                                <input
                                    asp-for="kilometr"
                                    type="number"
                                    name="kilometr"
                                    value={form.kilometr}
                                    onChange={e => http.handleChange(e, form, setForm)}
                                    disabled={form.mode != 'Kilometr'}
                                    placeholder="مثلا برای روغن 5000 کیلومتر"
                                    className="form-control"
                                    autoComplete="off" />
                                <span asp-validation-for="oilDateFa" className="text-danger"></span>
                            </div>
                        </div>

                        <div className="row mt-3">
                            <div className="col">
                                <label disabled={form.mode != 'Time'} asp-for="oilDateFa">تعداد روز سرویس</label>
                            </div>
                        </div>
                        <div className="row mt-1">
                            <div className="col">
                                <input
                                    asp-for="day"
                                    type="number"
                                    name="day"
                                    value={form.day}
                                    onChange={e => http.handleChange(e, form, setForm)}
                                    disabled={form.mode != 'Time'}
                                    placeholder="مثلا برای لاستیک 180 روز"
                                    className="form-control"
                                    autoComplete="off" />
                                <span asp-validation-for="oilDateFa" className="text-danger"></span>
                            </div>
                        </div>

                        <div className="row mt-3">
                            <div className="col">
                                <div className="row border rounded p-2 bg-light">
                                    <div className="row ">
                                        <div className="col">
                                            <label asp-for="distanceOil">کیلومتر طی شده  :</label>
                                            <span className="text-danger"> {form.distance}</span>
                                        </div>
                                        <div className="col">
                                            <label asp-for="distanceOil">تعداد روز طی شده : </label>
                                            <span className="text-danger"> {form.days}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="success" className="col btn btn-success btn-block myCustomButton"
                        onClick={e => {
                            if (form.id > 0)
                                setShowConfirm(true)
                            else
                                handlePost(e)
                        }}
                        disabled={isPosting}>
                        {isPosting &&
                            <div className="spinner-border spinner-border-sm" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>}
                        <span>&nbsp;&nbsp;&nbsp;تایید </span>
                    </Button>
                    <Button variant="danger" className="col btn btn-danger myCustomButton" data-bs-dismiss="modal"
                        onClick={(e) => handleCloseIng(e)}>
                        <span>&nbsp;&nbsp;&nbsp;انصراف</span>
                    </Button>
                </Modal.Footer>
            </Modal>
        </>

    );

}
